module.exports = __webpack_public_path__ + "static/img/mq.bfeadb02.svg";